<template>
  <div id="app">
      <div>
        <router-link to="/">
            <img class="circle" src="avatar.png">
            <div id="name">Sam Maksimovich</div>
        </router-link>
        <div id="about">CS student and recreational mathematician</div>
        <router-link style="margin-top: 5px;" id="more_about" class="link" to="/about"> More about me </router-link>
      </div>
      <span class="divider"></span>
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted: () => {
    
  }
}
</script>

<style>
#app {
  font-family: 'Tajawal', Helvetica, Arial, sans-serif;
  font-size: 14pt;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 100px;

  display: flex;
  justify-content: center;
}

.circle {
    height: 150px;
    width: 150px;
    background-color: transparent;
    border-radius: 50%;
    border: 2px solid dodgerblue;
    padding: 3px;
    display: inline-block;
    transition: padding 0.4s, border-width 0.4s, border-color 0.5s;
}

.circle:hover {
    border-color: forestgreen;
    padding: 5px;
    border-width: 3px;
}

.divider {
    width: 1px;
    background-color: gainsboro;
    border-radius: 20px;
    margin-left: 15px;
    margin-right: 15px;
}

#name {
    margin-top: 15px;
    font-family: Monospace;
    font-weight: lighter;
    font-size: 19pt;
}

#about, #more_about {
    font-size: 12pt;
    font-family: Monospace;
    width: 250px;
    margin-top: 5px;
}

a {
    text-decoration: none;
}

a:visited {
    color: initial;
}

.link {
    color:dodgerblue;
}

.link:visited {
    color:dodgerblue;
}

.link:hover {
    color: rgb(89, 171, 252);
}

.link:active {
    color: blue;
}

.title {
    font-weight: lighter;
    font-size: 20pt;
    text-align: left;
}

.date {
    margin-top: 5px;
    font-weight: lighter;
    font-size: 12pt;
    text-align: left;
    color: grey;
}

.content {
    margin-top: 15px;
    min-width: 800px;
    max-width: 1000px;
    text-align: left;
    line-height: 150%;
}

.quote {
	font-family: 'Nunito', san-serif;
	font-style: italic; 
	background: #EEEEEE;  
	display: table; 
	padding: 2px
}

.customButton {
  background-color: #0079F2;
  font-family: "Tajawal", serif; 
  font-size: 1em;
  border: 2px solid transparent;
  border-radius: 4px;
  padding: 5px;
  color: whitesmoke;
}

.customButton:hover {
  background-color: #1785F3;
}

.customButton:active {
  background-color: #2E91F4;
}

</style>
